import { render, staticRenderFns } from "./VxAutoSuggest.vue?vue&type=template&id=33de4d96&"
import script from "./VxAutoSuggest.vue?vue&type=script&lang=js&"
export * from "./VxAutoSuggest.vue?vue&type=script&lang=js&"
import style0 from "./VxAutoSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33de4d96')) {
      api.createRecord('33de4d96', component.options)
    } else {
      api.reload('33de4d96', component.options)
    }
    module.hot.accept("./VxAutoSuggest.vue?vue&type=template&id=33de4d96&", function () {
      api.rerender('33de4d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-auto-suggest/VxAutoSuggest.vue"
export default component.exports